import { FC, SVGProps } from "react";

export const SearchIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none" {...props}>
      <g clipPath="url(#clip0_2679_3527)">
        <path
          d="M20.6667 19.5301H19.6133L19.24 19.1701C20.5467 17.6501 21.3333 15.6767 21.3333 13.5301C21.3333 8.7434 17.4533 4.8634 12.6667 4.8634C7.88 4.8634 4 8.7434 4 13.5301C4 18.3167 7.88 22.1967 12.6667 22.1967C14.8133 22.1967 16.7867 21.4101 18.3067 20.1034L18.6667 20.4767V21.5301L25.3333 28.1834L27.32 26.1967L20.6667 19.5301ZM12.6667 19.5301C9.34667 19.5301 6.66667 16.8501 6.66667 13.5301C6.66667 10.2101 9.34667 7.53007 12.6667 7.53007C15.9867 7.53007 18.6667 10.2101 18.6667 13.5301C18.6667 16.8501 15.9867 19.5301 12.6667 19.5301Z"
          fill={props.fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2679_3527">
          <rect width="32" height="32" fill={props.fill} transform="translate(0 0.863403)" />
        </clipPath>
      </defs>
    </svg>
  );
};
